import { toast } from 'vue3-toastify'

export const defaultToastConfig = {
  hideProgressBar: true,
  transition: toast.TRANSITIONS.BOUNCE,
  autoClose: 5000,
  position: toast.POSITION.TOP_RIGHT,
  closeOnClick: false
}

export const toster = (text) => {
  toast.success(text, {
    ...defaultToastConfig,
    delay: 1000,
    closeOnClick: false,
    newestOnTop: true
  })
}

export const successToast = (text) => {
  toast.success(text, defaultToastConfig)
}
export const infoToast = (text) => {
  toast.info(text, { ...defaultToastConfig, autoClose: 4000 })
}

export const warningToast = (text) => {
  toast.warning(text, defaultToastConfig)
}

export const errorToast = (text) => {
  toast.error(text, { ...defaultToastConfig, autoClose: 7000 })
}

export const showliveToast = (event) => {
  const target = event.currentTarget
  const ele = target.nextElementSibling?.querySelector('#liveToast')
  ele?.classList.add('show')
}
